module.exports = __webpack_public_path__ + "static/media/Arrow2.2ebc87d2.jpg";